import { io } from 'socket.io-client'
import baseUrls from '../base-urls'
const socket = (totenId) => {
  let path = ""
  let baseUrl = ""
  if(baseUrls.io.includes("/hml")){
    path = "/hml/socket.io"
    baseUrl = baseUrls.io.split("/hml")[0]
  }else{
    path = "/socket.io"
    baseUrl = baseUrls.io
  }
  const conn = io(baseUrl, {path, transports: ["websocket"], query: {totenId}});
  setInterval(()=>{
    !conn.connected ? window.document.location.reload() : null
  }, 30000)
  return conn
}

export default socket